import DetectorInterface from "../DetectorInterface";
import Detector from '../Detector';

export default class Integer extends Detector implements DetectorInterface {

    public match(value: string): boolean {

        if (typeof value !== 'number') return false;

        return Number.isInteger(Number(value));
    }
}

